/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandLookupResponseDto
 */
export interface BrandLookupResponseDto {
    /**
     * Brand ID
     * @type {number}
     * @memberof BrandLookupResponseDto
     */
    id: number;
    /**
     * Unique brand code
     * @type {string}
     * @memberof BrandLookupResponseDto
     */
    code: string;
    /**
     * Brand name in English
     * @type {string}
     * @memberof BrandLookupResponseDto
     */
    nameEn: string;
    /**
     * Brand name in Arabic
     * @type {string}
     * @memberof BrandLookupResponseDto
     */
    nameAr: string | null;
    /**
     * Brand image URL
     * @type {string}
     * @memberof BrandLookupResponseDto
     */
    imageUrl: string | null;
    /**
     * Whether the brand is active
     * @type {boolean}
     * @memberof BrandLookupResponseDto
     */
    isActive: boolean;
    /**
     * Sort order for display
     * @type {number}
     * @memberof BrandLookupResponseDto
     */
    sortOrder: number | null;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof BrandLookupResponseDto
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof BrandLookupResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the BrandLookupResponseDto interface.
 */
export function instanceOfBrandLookupResponseDto(value: object): value is BrandLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function BrandLookupResponseDtoFromJSON(json: any): BrandLookupResponseDto {
    return BrandLookupResponseDtoFromJSONTyped(json, false);
}

export function BrandLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'],
        'imageUrl': json['imageUrl'],
        'isActive': json['isActive'],
        'sortOrder': json['sortOrder'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function BrandLookupResponseDtoToJSON(value?: BrandLookupResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

